export default __webpack_public_path__ + "static/media/480_dummy2016-fashion01-mobile-de.fcf32963.png";